import React from 'react';
import {
  Box,
  Grid,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';

const ReportsSkeleton = () => {
  return (
    <>
      {/* 8 Top KPI Statistics Cards Skeleton */}
      <Box className="kpi-cards-grid">
        <Grid container spacing={2.5}>
          {[...Array(8)].map((_, idx) => (
            <Grid item xs={12} sm={6} md={3} key={idx}>
              <Box className="kpi-card">
                <Skeleton
                  variant="text"
                  width="70%"
                  height={18}
                  animation="wave"
                  sx={{ mb: 1, borderRadius: '4px' }}
                />
                <Skeleton
                  variant="text"
                  width="45%"
                  height={36}
                  animation="wave"
                  sx={{ borderRadius: '6px' }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Staff Variance Summary Table Skeleton */}
      <Box className="staff-variance-section" sx={{ mt: 3 }}>
        <Box
          className="staff-variance-header"
          sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}
        >
          <Skeleton variant="circular" width={22} height={22} animation="wave" />
          <Skeleton
            variant="text"
            width={200}
            height={26}
            animation="wave"
            sx={{ borderRadius: '4px' }}
          />
        </Box>

        <TableContainer component={Paper} elevation={0}>
          <Table>
            <TableHead sx={{ bgcolor: '#F9FAFB' }}>
              <TableRow>
                <TableCell
                  sx={{
                    fontWeight: 600,
                    color: '#6B7280',
                    fontSize: '13px',
                    paddingLeft: '20px',
                  }}
                >
                  Staff
                </TableCell>
                <TableCell sx={{ fontWeight: 600, color: '#6B7280', fontSize: '13px' }}>
                  Shifts
                </TableCell>
                <TableCell sx={{ fontWeight: 600, color: '#6B7280', fontSize: '13px' }}>
                  Shortages
                </TableCell>
                <TableCell sx={{ fontWeight: 600, color: '#6B7280', fontSize: '13px' }}>
                  Surpluses
                </TableCell>
                <TableCell sx={{ fontWeight: 600, color: '#6B7280', fontSize: '13px' }}>
                  Net Variance
                </TableCell>
                <TableCell sx={{ fontWeight: 600, color: '#6B7280', fontSize: '13px' }}>
                  Largest
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {[...Array(4)].map((_, i) => (
                <TableRow
                  key={i}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell sx={{ paddingLeft: '20px' }}>
                    <Skeleton
                      variant="text"
                      width={120}
                      height={24}
                      animation="wave"
                      sx={{ borderRadius: '4px' }}
                    />
                  </TableCell>
                  <TableCell>
                    <Skeleton
                      variant="text"
                      width={40}
                      height={24}
                      animation="wave"
                      sx={{ borderRadius: '4px' }}
                    />
                  </TableCell>
                  <TableCell>
                    <Skeleton
                      variant="text"
                      width={65}
                      height={24}
                      animation="wave"
                      sx={{ borderRadius: '4px' }}
                    />
                  </TableCell>
                  <TableCell>
                    <Skeleton
                      variant="text"
                      width={65}
                      height={24}
                      animation="wave"
                      sx={{ borderRadius: '4px' }}
                    />
                  </TableCell>
                  <TableCell>
                    <Skeleton
                      variant="text"
                      width={75}
                      height={24}
                      animation="wave"
                      sx={{ borderRadius: '4px' }}
                    />
                  </TableCell>
                  <TableCell>
                    <Skeleton
                      variant="text"
                      width={65}
                      height={24}
                      animation="wave"
                      sx={{ borderRadius: '4px' }}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  );
};

export default ReportsSkeleton;
